import * as React from "react";
import {connect} from "react-redux";
import {WithApi, WithApiProperties} from "../common/util/WithApi";
import {actions} from "./actions";
import {ImportedDataSearchFilter, ApolloCatalogData} from "./model";
import {selectors} from "./selectors";
import {DataFolderTree} from "./DataFolderTree";
import {injectIntl} from "react-intl";
import {getSelectedPath} from "./Util"
import {AxiosError} from "axios";
import {Redirect} from "react-router-dom";
import {ErrorDisplay} from "../common/ui/errordisplay/ErrorDisplay";

interface DataFolderBrowserOwnProperties {
  notifyFilterChanged?: () => void;
}

interface DataFolderBrowserStateProperties {
  filter: ImportedDataSearchFilter;
  folders: ApolloCatalogData[];
}

interface DataFolderBrowserDispatchProperties {
  filterChanged: (filter: ImportedDataSearchFilter) => void;
  loadFolders: (folderID?: string) => Promise<void>;
}

interface DataFolderBrowserState {
  error: AxiosError;
}

type DataFolderBrowserComponentProperties =
    WithApiProperties
    & DataFolderBrowserOwnProperties
    & ReactIntl.InjectedIntlProps
    & DataFolderBrowserStateProperties
    & DataFolderBrowserDispatchProperties;

class DataFolderBrowserComponent extends React.Component<DataFolderBrowserComponentProperties, DataFolderBrowserState> {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
    }
  }

  componentDidMount() {
    this.props.loadFolders(this.props?.filter?.folder)
        .catch((error) => {
          this.setState({error});
        });
  }

  setFolder(folderId: string) {
    const filter = {...this.props.filter, folder: folderId};
    if (folderId === null) {
      delete filter.folder;
    }
    this.props.notifyFilterChanged();
    this.props.filterChanged(filter);
  }

  render() {
    const {error} = this.state;
    const {folders, filter} = this.props;
    const selectedPath = getSelectedPath(folders, filter.folder);

    if (error) {
      if (error?.response.status === 401) {
        return <Redirect to="/login"/>;
      }
      return <ErrorDisplay error={error}/>;
    }

    return (
        <div className="dataFolderBrowser">
          <DataFolderTree level={0} allFolders={this.props.folders} filter={this.props.filter}
                          filterChanged={(f) => this.setFolder(f)}
                          pathToExpand={selectedPath}
          />
        </div>
    );
  }
}

const mapStateToProps = (state, _ownProps) => ({
  filter: selectors.getFilter(state),
  folders: selectors.getFolders(state),
});

const mapDispatchToProps = (dispatch, _ownProps) => ({
  filterChanged: (filter: ImportedDataSearchFilter) => {
    dispatch(actions.setDataFilter(filter));
    dispatch(actions.clearData());
  },
  loadFolders: (folderId?: string) => {
    return dispatch(actions.loadFolders(folderId));
  },
});

export const DataFolderBrowser =
    connect(mapStateToProps, mapDispatchToProps)(WithApi(injectIntl(DataFolderBrowserComponent)));